import { render, staticRenderFns } from "./possibilityComponent.vue?vue&type=template&id=87ef79ca&"
import script from "./possibilityComponent.vue?vue&type=script&lang=js&"
export * from "./possibilityComponent.vue?vue&type=script&lang=js&"
import style0 from "./possibilityComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports